/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { SentenceEmbeddingsComparisonMatch } from './SentenceEmbeddingsComparisonMatch.js';
import {
    SentenceEmbeddingsComparisonMatchFromJSON,
    SentenceEmbeddingsComparisonMatchFromJSONTyped,
    SentenceEmbeddingsComparisonMatchToJSON,
} from './SentenceEmbeddingsComparisonMatch.js';
import type { Utterance } from './Utterance.js';
import {
    UtteranceFromJSON,
    UtteranceFromJSONTyped,
    UtteranceToJSON,
} from './Utterance.js';

/**
 * 
 * @export
 * @interface SearchSentencesResponseItem
 */
export interface SearchSentencesResponseItem {
    /**
     * 
     * @type {Utterance}
     * @memberof SearchSentencesResponseItem
     */
    utterance?: Utterance;
    /**
     * 
     * @type {Array<SentenceEmbeddingsComparisonMatch>}
     * @memberof SearchSentencesResponseItem
     */
    matches?: Array<SentenceEmbeddingsComparisonMatch>;
}

/**
 * Check if a given object implements the SearchSentencesResponseItem interface.
 */
export function instanceOfSearchSentencesResponseItem(value: object): boolean {
    return true;
}

export function SearchSentencesResponseItemFromJSON(json: any): SearchSentencesResponseItem {
    return SearchSentencesResponseItemFromJSONTyped(json, false);
}

export function SearchSentencesResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSentencesResponseItem {
    if (json == null) {
        return json;
    }
    return {
        
        'utterance': json['utterance'] == null ? undefined : UtteranceFromJSON(json['utterance']),
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(SentenceEmbeddingsComparisonMatchFromJSON)),
    };
}

export function SearchSentencesResponseItemToJSON(value?: SearchSentencesResponseItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'utterance': UtteranceToJSON(value['utterance']),
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(SentenceEmbeddingsComparisonMatchToJSON)),
    };
}

